// Import default MiniSettings from the shared JSON file (single source of truth)
import miniSettingsDefaults from '../FrontEndReact/src/CommonData/miniSettingsDefaults.json';

(function (angular) {
	angular.module('bizPartEngage', [
		'ng',
		'ngAnimate',
		'ngCookies',
		'ngSanitize',
		'ui.router',
		'bizPart',
		'ngMaterial',
		'ui.bootstrap',
		'ngMessages',
		'sticky',
		'multi-transclude',
		'ui.knob',
		'pascalprecht.translate',
		'SignalR',
		'BizContainer',
		'BizContainerHelper',
		'720kb.socialshare',
		'ngclipboard',
		'matchMedia',
		'oc.lazyLoad',
		'bizWelcomeGuide',
		'bizReactWrapper',
		'bizParentSelect',
	]);

	angular.module('bizPartEngage').constant('genericPosition', {
		TOP: 1,
		LEFT: 2,
		RIGHT: 3,
		BOTTOM: 4,
		CENTER: 5,
	});

	angular.module('bizPartEngage').provider('bizLevel', levelProvider);
	angular.module('bizPartEngage').provider('bizPortal', portalProvider);

	angular.module('bizPartEngage').provider('bizCore', coreProvider);
	angular.module('bizPartEngage').provider('bizUser', userProvider);

	angular.module('bizPartEngage').config(configFunction);
	angular.module('bizPartEngage').run(runFunction);
	angular.module('bizPartEngage').factory('loadingInterceptor', loadingInterceptorFunction);

	configFunction.$inject = [
		'$stateProvider',
		'$urlRouterProvider',
		'$httpProvider',
		'bizCoreProvider',
		'$translateProvider',
		'$translatePartialLoaderProvider',
		'$locationProvider',
		'bizPortalProvider',
		'bizUserProvider',
		'$ocLazyLoadProvider',
	];
	runFunction.$inject = [
		'$rootScope',
		'$http',
		'$q',
		'base.service',
		'bizUser',
		'$state',
		'core.users.service',
		'bizLevel',
		'$translate',
		'bizNotificationService',
		'SignalRFactory',
		'$transitions',
		'bizContainerSettings',
		'$location',
		'$window',
		'$translatePartialLoader',
		'core.session.service',
		'bizPortal',
		'genericPosition',
		'bizLoaderService',
		'$locale',
		'bizPushNotificationService',
		'bizJourneyService',
		'bizPageSurfaceService',
	];
	loadingInterceptorFunction.$inject = ['$q'];
	userProvider.$inject = ['bizPortalProvider', '$translateProvider'];

	function coreProvider() {
		var lastUpdate = moment();

		function GetView(stateName, fallback) {
			//Adding to make sure we get a new version of the HTML every hour...
			if (moment.duration(moment().diff(lastUpdate)).asHours() > 1) {
				lastUpdate = moment();
			}

			var override = viewOverrides.GetItemByValue('State', stateName);
			var themeOverride = portalTheme.Views.GetItemByValue('State', stateName);

			if (override) {
				return siteRootPath + override.ViewUrl;
			} else if (themeOverride) {
				return siteRootPath + themeOverride.ViewUrl;
			} else {
				return siteRootPath + fallback;
			}
		}

		function GetController(stateName, fallback) {
			var override = viewOverrides.GetItemByValue('State', stateName);

			if (override && override.Controller) {
				return override.Controller;
			} else {
				return fallback;
			}
		}

		function SetViewOverrides(overrides) {
			viewOverrides = overrides;
		}

		return {
			getView: GetView,
			getController: GetController,
			setViewOverrides: SetViewOverrides,
			$get: function () {
				return {
					getViewOverrides: function () {
						return viewOverrides;
					},
					getView: GetView,
					getController: GetController,
					setViewOverrides: SetViewOverrides,
				};
			},
		};
	}

	function userProvider(portalProvider, $translate) {
		if (userData.Token == null) userData.Token = getBizPartAuthToken();

		var LoggedInUser = userData;
		var AccessTypeRight = {
			Read: 10,
			Write: 20,
			WriteExtended: 30,
			Admin: 40,
		};

		function SetLoggedInUser(user) {
			LoggedInUser = user;
		}

		function HasWriteOrHigherAccess(accessTypeModuleKey) {
			var hasAccess = IsAdministrator();

			if (!hasAccess) {
				if (accessTypeModuleKey) {
					hasAccess = HasModuleAccess(accessTypeModuleKey, AccessTypeRight.Write);
				} else {
					try {
						for (var i = 0; i < LoggedInUser.Roles.length; i++) {
							if (hasAccess) {
								break;
							}
							if (LoggedInUser.Roles[i].AccessTypeAccesses) {
								for (var a = 0; a < LoggedInUser.Roles[i].AccessTypeAccesses.length; a++) {
									if (
										LoggedInUser.Roles[i].AccessTypeAccesses[a].AccessTypeRight >= AccessTypeRight.Write &&
										LoggedInUser.Roles[i].AccessTypeAccesses[a].AccessTypeModule.AccessTypeKey !==
											'ENGAGEMENT_GOAL'
									) {
										hasAccess = true;
										break;
									}
								}
							}
						}
					} catch (e) {
						console.error(e);
						hasAccess = false;
					}
				}
			}

			return hasAccess;
		}

		function HasModuleAccess(accessTypeModuleKey, accessTypeAccess, ignorePortalPublic) {
			if ((portalProvider.IsPortalPublic() && accessTypeAccess == 10 && !ignorePortalPublic) || IsAdministrator())
				return true;
			if (LoggedInUser.Roles) {
				try {
					//Checking user roles...
					for (var i = 0; i < LoggedInUser.Roles.length; i++) {
						if (LoggedInUser.Roles[i].AccessTypeAccesses) {
							for (var a = 0; a < LoggedInUser.Roles[i].AccessTypeAccesses.length; a++) {
								var correctModule =
									LoggedInUser.Roles[i].AccessTypeAccesses[a].AccessTypeModule.AccessTypeKey ==
									accessTypeModuleKey;
								if (
									correctModule &&
									~~LoggedInUser.Roles[i].AccessTypeAccesses[a].AccessTypeRight >= ~~accessTypeAccess
								)
									return true;
							}
						}
					}
				} catch (e) {
					console.error(e);
					return false;
				}
			}

			if (LoggedInUser.AllUnits) {
				try {
					//Checking user unit roles...
					for (var i = 0; i < LoggedInUser.AllUnits.length; i++) {
						for (var r = 0; r < LoggedInUser.AllUnits[i].Roles.length; r++) {
							if (LoggedInUser.AllUnits[i].Roles[r].AccessTypeAccesses) {
								for (var a = 0; a < LoggedInUser.AllUnits[i].Roles[r].AccessTypeAccesses.length; a++) {
									var correctModule =
										LoggedInUser.AllUnits[i].Roles[r].AccessTypeAccesses[a].AccessTypeModule.AccessTypeKey ==
										accessTypeModuleKey;
									if (
										correctModule &&
										~~LoggedInUser.AllUnits[i].Roles[r].AccessTypeAccesses[a].AccessTypeRight >=
											~~accessTypeAccess
									)
										return true;
								}
							}
						}
					}
				} catch (e) {
					console.error(e);
					return false;
				}
			}
			//console.warn('No access to: ', { accessTypeModuleKey: accessTypeModuleKey, accessTypeAccess: accessTypeAccess });
			return false;
		}

		function IsAdministrator() {
			const adminRoleSystemNames = ['ADMINISTRATOR', 'PortalAdmin', 'HostAdmin'];
			return LoggedInUser.Roles ? LoggedInUser.Roles.some((role) => adminRoleSystemNames.includes(role.SystemName)) : false;
		}

		function IsLoggedIn() {
			return ~~LoggedInUser.Id > 0;
		}

		return {
			AccessTypeRight: AccessTypeRight,
			HasModuleAccess: HasModuleAccess,
			IsAdministrator: IsAdministrator,
			HasWriteOrHigherAccess: HasWriteOrHigherAccess,
			IsLoggedIn: IsLoggedIn,
			SetLoggedInUser: SetLoggedInUser,
			$get: function () {
				return {
					setLoggedInUser: function (user) {
						LoggedInUser.Initials = IsLoggedIn() ? `${user.FirstName.slice(0, 1)}${user.LastName.slice(0, 1)}` : '';
						moment.locale(cultureCode.substring(0, 2));

						console.log('CULTURE: ' + cultureCode);
					},
					getLoggedInUser: function () {
						return LoggedInUser;
					},
					AccessTypeRight: AccessTypeRight,
					HasModuleAccess: HasModuleAccess,
					IsAdministrator: IsAdministrator,
					HasWriteOrHigherAccess: HasWriteOrHigherAccess,
					IsLoggedIn: IsLoggedIn,
					SetLoggedInUser: SetLoggedInUser,
				};
			},
		};
	}

	function levelProvider() {
		var translate;
		function getExperienceTypeLabel(key) {
			switch (~~key) {
				case 1:
					return translate('CORE.LOGIN');
				case 2:
					return translate('CORE.LOGINXDAYSWEEK');
				case 3:
					return translate('CORE.LOGINXDAYSMONTH');
				case 16:
					return translate('CORE.UNIQUEPAGEVISITS');
				case 18:
					return translate('CORE.EXPERIENCEGAINPERWEEKINUNIT');
				case 22:
					return translate('CORE.HTML5EDUCATION');
			}
		}

		function setTranslateProvider(t) {
			translate = t;
		}

		return {
			getExperienceTypeLabel: getExperienceTypeLabel,
			setTranslateProvider: setTranslateProvider,
			$get: function () {
				return {
					getExperienceTypeLabel: getExperienceTypeLabel,
					setTranslateProvider: setTranslateProvider,
				};
			},
		};
	}

	function portalProvider() {
		var PublicPortal = false;

		function IsPortalPublic() {
			return PublicPortal;
		}

		function SetPublicPortal(val) {
			PublicPortal = val;
		}

		return {
			IsPortalPublic: IsPortalPublic,
			SetPublicPortal: SetPublicPortal,
			$get: function () {
				return {
					IsPortalPublic: IsPortalPublic,
					SetPublicPortal: SetPublicPortal,
				};
			},
		};
	}

	function configFunction(
		$stateProvider,
		$urlRouterProvider,
		$httpProvider,
		bizCoreProvider,
		$translateProvider,
		$translatePartialLoaderProvider,
		$locationProvider,
		portalProvider,
		userProvider,
		$ocLazyLoadProvider
	) {
		$urlRouterProvider.otherwise('/');
		$locationProvider.html5Mode(true);
		//$locationProvider.hashPrefix('!');

		$ocLazyLoadProvider.config({
			modules: GetLazyLoadModules(),
		});

		$stateProvider
			.state('base', {
				templateUrl: bizCoreProvider.getView('base', 'FrontEnd/Views/base.html'),
				controller: bizCoreProvider.getController('base', 'base'),
				controllerAs: 'vm',
			})
			.state('noaccess', {
				url: '/noaccess',
				templateUrl: bizCoreProvider.getView('noaccess', 'FrontEnd/Views/noaccess.html'),
				controller: bizCoreProvider.getController('noaccess', 'base.noaccess'),
				controllerAs: 'vm',
				data: {
					isPublic: true,
				},
			})
			.state('login', {
				url: '/login',
				templateUrl: bizCoreProvider.getView(
					'base.core.login',
					'FrontEnd/Core/Themes/Login5050WithBgImages/Views/login.html'
				),
				controller: 'core.login',
				controllerAs: 'vm',
				data: {
					isPublic: true,
					onlyLoggedOut: true,
				},
			})
			.state('logout', {
				url: '/logout',
				templateUrl: bizCoreProvider.getView('base.core.logout', 'FrontEnd/Core/Views/logout.html'),
				controller: 'core.logout',
				controllerAs: 'vm',
			})
			.state('activateaccount', {
				url: '/activateaccount/:guid',
				templateUrl: bizCoreProvider.getView(
					'base.core.login',
					'FrontEnd/Core/Themes/Login5050WithBgImages/Views/login.html'
				),
				controller: 'core.login',
				controllerAs: 'vm',
				data: {
					isPublic: true,
					onlyLoggedOut: true,
				},
			})
			.state('forgotpassword', {
				url: '/forgotpassword',
				templateUrl: bizCoreProvider.getView(
					'core.forgotpassword',
					'FrontEnd/Core/Themes/Login5050WithBgImages/Views/forgotpassword.html'
				),
				controller: 'core.forgotpassword',
				controllerAs: 'vm',
				data: {
					isPublic: true,
				},
			})
			.state('changepassword', {
				url: '/forgotpassword/:guid',
				templateUrl: bizCoreProvider.getView(
					'core.forgotpassword',
					'FrontEnd/Core/Themes/Login5050WithBgImages/Views/forgotpassword.html'
				),
				controller: 'core.changepassword',
				controllerAs: 'vm',
				data: {
					isPublic: true,
				},
			})
			.state('base.home', {
				url: '/',
				templateUrl: bizCoreProvider.getView('base.home', 'FrontEnd/Views/home.html'),
				controller: bizCoreProvider.getController('base.home', 'base.home'),
				controllerAs: 'vm',
			})
			.state('cleanbase', {
				templateUrl: bizCoreProvider.getView('cleanbase', 'FrontEnd/Views/cleanbase.html'),
				controller: bizCoreProvider.getController('base', 'base'),
				controllerAs: 'vm',
			});

		$httpProvider.interceptors.push('loadingInterceptor');
		$httpProvider.useApplyAsync(true);

		$translatePartialLoaderProvider.addPart('_combined');

		var culture = cultureCode.substring(0, 2);
		var customerLangs = portalSettings['CustomerTranslationLangs'];

		if (customerLangs.includes(culture)) {
			$translatePartialLoaderProvider.addPart('customer/' + portalAlias);
		}

		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: siteRootPath + 'FrontEnd/i18n/{part}/{lang}.json?v=' + bizPartVersion,
		});

		$translateProvider.preferredLanguage(culture);
		$translateProvider.fallbackLanguage(customerLangs.includes('sv') ? 'sv' : 'en');

		$translateProvider.forceAsyncReload(true);
		$translateProvider.useLoaderCache(true);
		moment.locale(culture);
		$translateProvider.useSanitizeValueStrategy('sce');

		portalProvider.SetPublicPortal(IsPortalSettingTrue('IsPortalPublic'));

		// $translateProvider.preferredLanguage(culture);
		// $translateProvider.forceAsyncReload(true);
		// $translateProvider.useLoaderCache(true);
		// $translateProvider.fallbackLanguage('sv');
		// $translateProvider.useSanitizeValueStrategy('sce');
	}

	function runFunction(
		$rootScope,
		$http,
		$q,
		baseService,
		bizUser,
		$state,
		userService,
		levelProvider,
		$translate,
		bizNotificationService,
		SignalRFactory,
		$transitions,
		bizContainerSettings,
		$location,
		$window,
		$translatePartialLoader,
		sessionService,
		portalProvider,
		genericPosition,
		bizLoaderService,
		$locale,
		bizPushNotificationService,
		bizJourneyService,
		bizPageSurfaceService
	) {
		var initializationDefer = $q.defer();
		$rootScope.CultureDefer = $q.defer();
		$rootScope.Initialized = initializationDefer.promise;
		$rootScope.CultureInitialized = $rootScope.CultureDefer.promise;

		$rootScope.$on('$translatePartialLoaderStructureChanged', function () {
			$translate.refresh();
		});

		$rootScope.RequestFullPageLoader = bizLoaderService.RequestFullPageLoader;

		levelProvider.setTranslateProvider($translate);

		$rootScope.AuthToken = getBizPartAuthToken();
		if (typeof isTestMode === 'undefined' || !isTestMode) {
			$http.defaults.headers.common['Auth-Token'] = $rootScope.AuthToken;
		}

		$http.defaults.headers.common['PortalId'] = portalId;
		$http.defaults.headers.common['Cache-Control'] = 'max-age=1800, private';
		$http.defaults.headers.common['Pragma'] = undefined;
		$rootScope.logo = portalSettings['logo'];
		$rootScope.poweredby = GetPlatformImageUrl('PoweredByLogo');
		$rootScope.QueryParams = $location.search();
		$rootScope.menuSettings = menuSettings;
		$rootScope.genericpositions = genericPosition;
		$rootScope.maxWidth = portalSettings['maxWidth'];
		$rootScope.mascotName = mascot.Name;

		$rootScope.GetFullscreenCalc = GetFullscreenCalc;
		$rootScope.getFullscreenWidth = getFullscreenWidth;
		$rootScope.scrollWidth = GetScrollWidth;

		$rootScope.DisableMainMenuSticky = !$rootScope.menuSettings.IsSticky;
		$rootScope.Theme = portalTheme;
		$rootScope.UnitSettings = GetUnitSettings();
		$rootScope.IsInIframe = window.location !== window.parent.location;
		$rootScope.HasWebpSupport = false;
		$rootScope.PasswordRegex = new RegExp(portalSettings['PasswordRegEx']);
		$rootScope.PasswordMinLen = 8;

		$rootScope.GetPlatformImageUrl = GetPlatformImageUrl;

		function GetUnitSettings() {
			// console.log('GetUnitSettings');
			var unitcookie = getCookie('UnitSettings');

			if (unitcookie === null || unitcookie === '') return null;

			return JSON.parse(unitcookie);
		}

		$rootScope.GetUnitSettingsImage = function () {
			if (!$rootScope.UnitSettings) {
				return;
			}

			var image = $rootScope.UnitSettings.Image;

			var isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
			if (isDarkMode && $rootScope.UnitSettings.ImageDarkMode && $rootScope.UnitSettings.ImageDarkMode.length > 0) {
				image = $rootScope.UnitSettings.ImageDarkMode;
			}

			return image;
		};

		$rootScope.RandomBetween = function (min, max) {
			return Math.floor(Math.random() * (max - min + 1) + min);
		};

		$rootScope.GetPreloadedPortalSetting = function (key) {
			return portalSettings[key];
		};

		$rootScope.HasAcceptedCookieOfType = function (type) {
			if (!type) return false;

			if (typeof CustomCheckCookieConsentFn === 'function') {
				return CustomCheckCookieConsentFn(type);
			}

			var normalizedType = type.toLowerCase();
			if (normalizedType === 'functional' || normalizedType === 'necessary') return true;
			var categoryKey = null;
			if (normalizedType === 'statistics') categoryKey = 'HasAcceptedStatisticsCookies';
			else if (normalizedType === 'marketing') categoryKey = 'HasAcceptedMarketingCookies';
			else return false;

			var categoryConsent = getLocalStorage(categoryKey);
			if (categoryConsent !== null) return categoryConsent === 'true';

			return getLocalStorage('HasAcceptedCookies') === 'true';
		};

		function loadMiniSettings(saved) {
			// Default MiniSettings loaded from shared JSON file (single source of truth)
			// Function-type properties are added here since they can't be stored in JSON
			var defaults = JSON.parse(JSON.stringify(miniSettingsDefaults));
			console.log('defaultMiniSettings from JSON', defaults);
			// Add function-type defaults that can't be in JSON
			defaults.Profile.AdditionalProfileSubMenuItems = [];
			defaults.Profile.CustomGenderFilterFn = undefined;
			defaults.Register.UserSettings = undefined;
			defaults.Register.UserSettingsGetFn = undefined;
			defaults.Register.UserSettingsFilterFn = undefined;
			defaults.Logout = { CustomLogoutFn: undefined };

			if (!saved) return defaults;

			/**
			 * Deep merge MiniSettings, preserving function properties from defaults
			 * and merging saved settings from the database.
			 * Custom runconfig.js can still override any property after this.
			 */

			var result = {};
			for (var groupKey in defaults) {
				if (defaults.hasOwnProperty(groupKey)) {
					result[groupKey] = {};
					var defaultGroup = defaults[groupKey];
					var savedGroup = saved[groupKey] || {};

					for (var settingKey in defaultGroup) {
						if (defaultGroup.hasOwnProperty(settingKey)) {
							var defaultValue = defaultGroup[settingKey];
							var savedValue = savedGroup[settingKey];

							// Keep default if saved value is undefined or if default is a function
							if (typeof defaultValue === 'function') {
								result[groupKey][settingKey] = defaultValue;
							} else if (savedValue !== undefined) {
								result[groupKey][settingKey] = savedValue;
							} else {
								result[groupKey][settingKey] = defaultValue;
							}
						}
					}
				}
			}

			// Also copy any additional groups from saved settings (like CustomTexts)
			for (var savedGroupKey in saved) {
				if (saved.hasOwnProperty(savedGroupKey) && !defaults.hasOwnProperty(savedGroupKey)) {
					result[savedGroupKey] = saved[savedGroupKey];
				}
			}

			return result;
		}

		// Initialize MiniSettings by merging defaults with saved settings from database
		// The savedMiniSettings variable is set in Index.cshtml via ViewBag.MiniSettings
		$rootScope.MiniSettings = loadMiniSettings(typeof savedMiniSettings !== 'undefined' ? savedMiniSettings : null);

		$rootScope.GetMiniSetting = function (module, key) {
			return $rootScope.MiniSettings[module][key];
		};

		check_webp_feature('lossy', function (feature, res) {
			//console.log(feature, res);
			if (res === false) {
				$rootScope.HasWebpSupport = false;
				hasWebpSupport = false;
			}
		});

		function getFullscreenWidth() {
			return '100vw';
			// if ($(document).height() > $(window).height()) {
			// 	return 'calc(100vw - ' + GetScrollWidth() + 'px)';
			// } else {
			// 	return '100vw';
			// }
		}

		function GetFullscreenCalc() {
			if (portalSettings.maxWidth.length > 0) {
				return 'calc(-100vw / 2 + ' + portalSettings.maxWidth + ' / 2)';
			} else {
				return 'calc(-100vw / 2 + 100% / 2)';
			}
		}

		function GetScrollWidth() {
			// Got 11px when the container-page was using the setting: Content align: center, changed to left...
			// normaly 17px for windows, 0px on OS X depending on settings.
			var scrollWidth = window.innerWidth - $(document).width();

			//console.log('scrollWidth', scrollWidth);

			// This is some scaling issue?
			if (scrollWidth == 16) {
				scrollWidth = 17;
			}

			if (scrollWidth > 17 || scrollWidth < 0) scrollWidth = 17;

			return scrollWidth;
		}

		$rootScope.$on('$locationChangeSuccess', function (newValue) {
			$rootScope.QueryParams = $location.search();
			$rootScope.ExpandMainMenu = false;

			if (!$rootScope.PreventScrollTopOnce) $window.scrollTo(0, 0);

			$rootScope.PreventScrollTopOnce = false;
		});

		// A visible login/public page also receives foreground pushes. Do not wait for login.
		if (IsPortalSettingTrue('IsPushNotificationsEnabled')) {
			bizPushNotificationService.InitializeReceiver();
		}
		$q.all([baseService.GetLoggedInUser()]).then(LoadDataDone);

		function LoadDataDone(response) {
			bizUser.setLoggedInUser(response[0].data);
			$rootScope.LoggedInUser = bizUser.getLoggedInUser();
			$rootScope.LoggedInUser.CurrentCultureId = currentCultureId;
			$rootScope.LoggedInUser.CurrentCulture = cultureCode;
			$rootScope.IsLoggedIn = bizUser.IsLoggedIn();
			$rootScope.Logout = userService.Logout;
			$rootScope.HasModuleAccess = bizUser.HasModuleAccess;
			$rootScope.AccessTypeRight = bizUser.AccessTypeRight;
			$rootScope.HasWriteOrHigherAccess = bizUser.HasWriteOrHigherAccess;
			$rootScope.IsAdministrator = bizUser.IsAdministrator;
			bizContainerSettings.CurrentUserId = $rootScope.LoggedInUser.Id;
			bizContainerSettings.CurrentUserCurrency = $rootScope.LoggedInUser.DefaultVirtualCurrencyValue;
			$rootScope.ShowXP =
				IsPortalSettingTrue('IsLevelSystemEnabled') &&
				bizUser.HasModuleAccess('LEVEL_SYSTEM', bizUser.AccessTypeRight.Read);
			$rootScope.ShowCurrency = true; //for use later, when currency is actually implemented
			bizContainerSettings.CurrentUserId = $rootScope.LoggedInUser.Id;

			if (cultureCode === 'sv-SE') {
				$locale.NUMBER_FORMATS.GROUP_SEP = ' ';
			}

			initializationDefer.resolve(true);
			console.log('angularjs initialized complete');
			document.dispatchEvent(new CustomEvent('BizpartfrontendInitialized'));

			if (bizUser.IsLoggedIn()) {
				sessionService.Initialize(sessionTimeoutInSeconds);
				sessionService.Start();
				if (IsPortalSettingTrue('IsPushNotificationsEnabled')) {
					bizPushNotificationService.Initialize();
				}
				document.body.classList.add('logged-in-user');
			} else {
				document.body.classList.remove('logged-in-user');
			}

			if (portalProvider.IsPortalPublic() || bizUser.IsLoggedIn()) {
				baseService.GetMenuBySystemName('MAINMENU').then(function (response) {
					$rootScope.MenuItems = response.data.items;
				});
				LoadAppMenu();
			}

			$rootScope.SendHubMessageToServer('USER_NOTIFICATION', 'SEND_UNREAD_NOTIFICATIONS');

			createFallbackFavicon($rootScope.Theme.PrimaryColor, $rootScope.Theme.PrimaryTextColor);

			if (navigator.connection) {
				navigator.connection.addEventListener('change', updateConnectionStatus);
				updateConnectionStatus();
			}
		}

		$rootScope.$on('USER_UPDATED', HandleUserUpdated);

		function HandleUserUpdated() {
			if (portalProvider.IsPortalPublic() || bizUser.IsLoggedIn()) {
				baseService.GetMenuBySystemName('MAINMENU').then(function (response) {
					$rootScope.MenuItems = response.data.items;
					$rootScope.$broadcast('MAIN_MENU_UPDATED');
				});
				LoadAppMenu();
			}
		}

		function LoadAppMenu() {
			if (!IsPortalSettingTrue('IsAppMenuEnabled')) {
				$rootScope.AppMenuResponse = null;
				$rootScope.IsAppMenuVisible = false;
				return;
			}

			baseService.GetMenuBySystemName('APPMENU').then(function (response) {
				$rootScope.AppMenuResponse = response.data;
			});
		}

		// JOURNEY
		var journeysDefer = $q.defer();
		$rootScope.JourneysInitialized = journeysDefer.promise;
		if (IsPortalSettingTrue('IsJourneyEnabled') && (bizUser.IsLoggedIn() || IsPortalSettingTrue('IsPortalPublic'))) {
			bizJourneyService.GetEngageJourneys().then((response) => {
				journeysDefer.resolve('');
				$rootScope.Journeys = response.data;
			});
		} else {
			journeysDefer.resolve('');
			$rootScope.Journeys = [];
		}
		$rootScope.$on('engageobject.finished', HandleEngageObjectFinished);

		$rootScope.GetNextJourneyItem = function (firstIfAllComplete) {
			var defer = $q.defer();
			$rootScope.JourneysInitialized.then(() => {
				if ($rootScope.Journeys) {
					var currentJourneyIsDone = false;
					var firstObject;
					for (var i = 0; i < $rootScope.Journeys.length; i++) {
						if ($rootScope.Journeys[i].IsCurrentJourney || currentJourneyIsDone) {
							var currentJourney = $rootScope.Journeys[i];
							for (var j = 0; j < currentJourney.EngageObjects.length; j++) {
								if (!firstObject) firstObject = currentJourney.EngageObjects[i];

								if (currentJourney.EngageObjects[j].Status !== 3) {
									defer.resolve(currentJourney.EngageObjects[j]);
									return;
								}
							}
							currentJourneyIsDone = true;
						}
					}
					if (firstIfAllComplete && firstObject) {
						defer.resolve(firstObject);
						return;
					}
				}
				defer.resolve(null);
			});
			return defer.promise;
		};

		$rootScope.IsJourneyStarted = function () {
			var defer = $q.defer();
			$rootScope.JourneysInitialized.then(() => {
				if ($rootScope.Journeys) {
					for (var i = 0; i < $rootScope.Journeys.length; i++) {
						if ($rootScope.Journeys[i].IsCurrentJourney) {
							var currentJourney = $rootScope.Journeys[i];
							for (var j = 0; j < currentJourney.EngageObjects.length; j++) {
								if (currentJourney.EngageObjects[j].Status === 3) {
									defer.resolve(true);
									return;
								}
							}
						}
					}
				}
				defer.resolve(false);
			});
			return defer.promise;
		};

		$rootScope.SetCurrentJourney = function (id, gotoNextObject, gotoFirstIfDone) {
			if ($rootScope.Journeys && $rootScope.Journeys.length) {
				bizJourneyService.SetCurrentJourney(id).then(() => {
					var currentJourney;
					var previousJourneyId;
					for (var i = 0; i < $rootScope.Journeys.length; i++) {
						if (!previousJourneyId && $rootScope.Journeys[i].IsCurrentJourney) {
							previousJourneyId = $rootScope.Journeys[i].Id;
						}
						$rootScope.Journeys[i].IsCurrentJourney = $rootScope.Journeys[i].Id === id;

						if ($rootScope.Journeys[i].IsCurrentJourney) {
							currentJourney = $rootScope.Journeys[i];
						}
					}

					if (previousJourneyId !== id) {
						$rootScope.bizBroadcast('CURRENT_JOURNEY_CHANGED', id);
					}

					if (gotoNextObject && currentJourney) {
						var nextObject;
						for (var i = 0; i < currentJourney.EngageObjects.length; i++) {
							if (!nextObject && currentJourney.EngageObjects[i].Status !== 3) {
								nextObject = currentJourney.EngageObjects[i];
							}
						}

						if (gotoFirstIfDone && !nextObject && currentJourney.EngageObjects.length > 0) {
							nextObject = currentJourney.EngageObjects[0];
						}

						if (nextObject) {
							bizJourneyService.GoToEngageItem(nextObject);
						}
					}
				});
			}
		};

		$rootScope.GetAllJourneysTotalProgress = function () {
			var defer = $q.defer();
			$rootScope.JourneysInitialized.then(() => {
				var objectCount = 0;
				var objectDoneCount = 0;
				if ($rootScope.Journeys) {
					for (var i = 0; i < $rootScope.Journeys.length; i++) {
						for (var j = 0; j < $rootScope.Journeys[i].EngageObjects.length; j++) {
							objectCount++;
							if ($rootScope.Journeys[i].EngageObjects[j].Status === 3) {
								objectDoneCount++;
							}
						}
					}
				}
				var p = 0;
				if (objectCount > 0) {
					p = (objectDoneCount * 100) / objectCount;
				}
				defer.resolve(p);
			});
			return defer.promise;
		};

		function HandleEngageObjectFinished(event, args) {
			if (args.status === 3 && $rootScope.Journeys) {
				var updatedObjectType = args.objectType;
				var updatedObjectId = args.objectId;
				var updatedToStatus = args.status;
				var anyUpdated = false;
				for (var i = 0; i < $rootScope.Journeys.length; i++) {
					var updateJourneyProgress = false;
					var journey = $rootScope.Journeys[i];
					if (journey.EngageObjects.length) {
						var finishedCount = 0;
						for (var j = 0; j < journey.EngageObjects.length; j++) {
							var eo = journey.EngageObjects[j];
							if (
								eo.Id === updatedObjectId &&
								eo.EngageObjectType === updatedObjectType &&
								eo.Status !== updatedToStatus &&
								eo.Status !== 3 //never update if already finished, to avoid progress going backwards if for some reason we get multiple events with different status for the same object
							) {
								eo.Status = updatedToStatus;
								updateJourneyProgress = true;
								anyUpdated = true;
							}
							if (eo.Status === 3) {
								finishedCount++;
							}
						}
						if (updateJourneyProgress) {
							journey.TotalProgress = (finishedCount * 100) / journey.EngageObjects.length;
						}
					}
				}

				if (anyUpdated) {
					$rootScope.$broadcast('JOURNEY_OBJECT_UPDATED');
				}
			}
		}

		//CONTAINER CONFIG
		bizContainerSettings.PortalCustomerName = '';
		bizContainerSettings.PortalVersion = 1;
		bizContainerSettings.PortalDefaultCulture = 1;
		bizContainerSettings.UseApiController = true;
		bizContainerSettings.UseEngageCore = true;

		function initializeStatistics() {
			if (!$rootScope.HasAcceptedCookieOfType('statistics')) return;
			setStatisticsCollectionDisabled(false);

			if (portalSettings['GoogleAnalyticsId'] && !$rootScope.GoogleAnalyticsInitialized) {
				$window.GoogleAnalyticsObject = 'ga';
				$window.ga =
					$window.ga ||
					function () {
						($window.ga.q = $window.ga.q || []).push(arguments);
					};
				$window.ga.l = 1 * new Date();
				var analyticsScript = document.createElement('script');
				analyticsScript.async = true;
				analyticsScript.src = 'https://www.google-analytics.com/analytics.js';
				document.head.appendChild(analyticsScript);
				$rootScope.GoogleAnalyticsInitialized = true;
			}

			if (portalSettings['GoogleTagManagerId'] && !$rootScope.GoogleTagManagerInitialized) {
				$window.dataLayer = $window.dataLayer || [];
				$window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
				var tagManagerScript = document.createElement('script');
				tagManagerScript.async = true;
				tagManagerScript.src =
					'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(portalSettings['GoogleTagManagerId']);
				document.head.appendChild(tagManagerScript);
				$rootScope.GoogleTagManagerInitialized = true;
			}

			initializeGoogleAnalyticsTrackers();
		}

		function setStatisticsCollectionDisabled(disabled) {
			if (portalSettings['GoogleAnalyticsId']) {
				portalSettings['GoogleAnalyticsId'].split(';').forEach(function (id) {
					$window['ga-disable-' + id] = disabled;
				});
			}
			$window.dataLayer = $window.dataLayer || [];
			$window.gtag =
				$window.gtag ||
				function () {
					$window.dataLayer.push(arguments);
				};
			$window.gtag('consent', 'update', {
				analytics_storage: disabled ? 'denied' : 'granted',
			});
			$window.dataLayer.push({
				event: 'cookieConsentUpdate',
				analytics_storage: disabled ? 'denied' : 'granted',
			});
		}

		function initializeGoogleAnalyticsTrackers() {
			if (!portalSettings['GoogleAnalyticsId'] || $rootScope.GoogleAnalyticsTrackersInitialized) return;

			$rootScope.GoogleAnalyticCustomTrackers = [];
			if (portalSettings['GoogleAnalyticsId'].indexOf(';') > 0) {
				var items = portalSettings['GoogleAnalyticsId'].split(';');
				$window.ga('create', items[0], 'auto');

				for (var i = 1; i < items.length; i++) {
					$rootScope.GoogleAnalyticCustomTrackers.push({
						Id: items[i],
						Name: 'customTracker_' + i,
					});
				}

				for (var i = 0; i < $rootScope.GoogleAnalyticCustomTrackers.length; i++) {
					var id = $rootScope.GoogleAnalyticCustomTrackers[i].Id;
					var name = $rootScope.GoogleAnalyticCustomTrackers[i].Name;
					$window.ga('create', id, 'auto', name);
				}
			} else {
				$window.ga('create', portalSettings['GoogleAnalyticsId'], 'auto');
			}
			$rootScope.GoogleAnalyticsTrackersInitialized = true;
		}

		function initializeMarketing() {
			if (!$rootScope.HasAcceptedCookieOfType('marketing')) return;
			setMarketingCollectionDisabled(false);

			if (portalSettings['MetaPixelId'] && !$rootScope.MetaPixelInitialized) {
				(function (f, b, e, v, n, t, s) {
					if (f.fbq) return;
					n = f.fbq = function () {
						n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
					};
					if (!f._fbq) f._fbq = n;
					n.push = n;
					n.loaded = true;
					n.version = '2.0';
					n.queue = [];
					t = b.createElement(e);
					t.async = true;
					t.src = v;
					s = b.getElementsByTagName(e)[0];
					s.parentNode.insertBefore(t, s);
				})($window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
				$window.fbq('init', portalSettings['MetaPixelId']);
				$rootScope.MetaPixelInitialized = true;
			}

			if (portalSettings['LinkedInInsightTagPartnerId'] && !$rootScope.LinkedInInsightTagInitialized) {
				$window._linkedin_partner_id = portalSettings['LinkedInInsightTagPartnerId'];
				$window._linkedin_data_partner_ids = $window._linkedin_data_partner_ids || [];
				$window._linkedin_data_partner_ids.push($window._linkedin_partner_id);
				if (!$window.lintrk) {
					$window.lintrk = function (a, b) {
						$window.lintrk.q.push([a, b]);
					};
					$window.lintrk.q = [];
				}
				var linkedInScript = document.createElement('script');
				linkedInScript.id = 'biz-linkedin-insight-tag';
				linkedInScript.async = true;
				linkedInScript.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
				document.head.appendChild(linkedInScript);
				$rootScope.LinkedInInsightTagInitialized = true;
			}

			if (portalSettings['TikTokPixelId'] && !$rootScope.TikTokPixelInitialized) {
				(function (w, d, t) {
					w.TiktokAnalyticsObject = t;
					var ttq = (w[t] = w[t] || []);
					ttq.methods = [
						'page',
						'track',
						'identify',
						'instances',
						'debug',
						'on',
						'off',
						'once',
						'ready',
						'alias',
						'group',
						'enableCookie',
						'disableCookie',
					];
					ttq.setAndDefer = function (target, method) {
						target[method] = function () {
							target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
						};
					};
					for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
					ttq.instance = function (pixelId) {
						var instance = ttq._i[pixelId] || [];
						for (var j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(instance, ttq.methods[j]);
						return instance;
					};
					ttq.load = function (pixelId, options) {
						var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
						ttq._i = ttq._i || {};
						ttq._i[pixelId] = [];
						ttq._i[pixelId]._u = url;
						ttq._t = ttq._t || {};
						ttq._t[pixelId] = +new Date();
						ttq._o = ttq._o || {};
						ttq._o[pixelId] = options || {};
						var script = d.createElement('script');
						script.async = true;
						script.src = url + '?sdkid=' + encodeURIComponent(pixelId) + '&lib=' + t;
						d.head.appendChild(script);
					};
				})(window, document, 'ttq');
				$window.ttq.load(portalSettings['TikTokPixelId']);
				$rootScope.TikTokPixelInitialized = true;
			}
		}

		function trackMarketingPageView() {
			if (!$rootScope.HasAcceptedCookieOfType('marketing')) return;
			if ($rootScope.MetaPixelInitialized) $window.fbq('track', 'PageView');
			if ($rootScope.TikTokPixelInitialized) $window.ttq.page();
		}

		function setMarketingCollectionDisabled(disabled) {
			if ($window.fbq) $window.fbq('consent', disabled ? 'revoke' : 'grant');
			if ($window.ttq) {
				if (disabled && $window.ttq.disableCookie) $window.ttq.disableCookie();
				else if (!disabled && $window.ttq.enableCookie) $window.ttq.enableCookie();
			}
			if (disabled && $rootScope.LinkedInInsightTagInitialized) {
				var linkedInScript = document.getElementById('biz-linkedin-insight-tag');
				if (linkedInScript && linkedInScript.parentNode) linkedInScript.parentNode.removeChild(linkedInScript);
				$window.lintrk = undefined;
				$window._linkedin_partner_id = undefined;
				$window._linkedin_data_partner_ids = [];
				$rootScope.LinkedInInsightTagInitialized = false;
				deleteCookieForAllPaths('li_fat_id');
			}
		}

		function deleteCookieForAllPaths(name) {
			var paths = ['/'];
			var pathParts = window.location.pathname.split('/').filter(Boolean);
			var currentPath = '';
			for (var i = 0; i < pathParts.length; i++) {
				currentPath += '/' + pathParts[i];
				paths.push(currentPath);
			}
			for (var j = 0; j < paths.length; j++) {
				document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + paths[j] + '; SameSite=Lax';
			}
		}

		setStatisticsCollectionDisabled(!$rootScope.HasAcceptedCookieOfType('statistics'));
		initializeStatistics();
		var marketingConsentActive = $rootScope.HasAcceptedCookieOfType('marketing');
		setMarketingCollectionDisabled(!marketingConsentActive);
		initializeMarketing();
		$rootScope.$on('cookieConsentChanged', function () {
			var statisticsAccepted = $rootScope.HasAcceptedCookieOfType('statistics');
			setStatisticsCollectionDisabled(!statisticsAccepted);
			if (statisticsAccepted) initializeStatistics();
			var marketingAccepted = $rootScope.HasAcceptedCookieOfType('marketing');
			setMarketingCollectionDisabled(!marketingAccepted);
			if (marketingAccepted) {
				initializeMarketing();
				if (!marketingConsentActive) trackMarketingPageView();
			}
			marketingConsentActive = marketingAccepted;
		});

		$transitions.onSuccess({}, function ($transition) {
			$rootScope.PreviousState = $transition.$from();
			$rootScope.CurrentState = $transition.$to();
			$rootScope.CurrentStateClass = $rootScope.CurrentState.name.replace(/\./g, '-');

			var currentCustomStateClassForBody = $rootScope.CurrentStateClass + '-custom-state';
			angular
				.element('.bizpart-engage')
				.removeClass(function (index, className) {
					var classes = className.split(' ').filter(function (c) {
						return c.endsWith('-custom-state');
					});
					return classes.join(' ');
				})
				.addClass(currentCustomStateClassForBody);

			if ($rootScope.HasAcceptedCookieOfType('statistics')) {
				if (portalSettings['GoogleAnalyticsId']) {
					$window.ga('send', 'pageview', $location.path());
				}

				if ($rootScope.GoogleAnalyticCustomTrackers) {
					for (var i = 0; i < $rootScope.GoogleAnalyticCustomTrackers.length; i++) {
						var name = $rootScope.GoogleAnalyticCustomTrackers[i].Name;
						$window.ga(name + '.send', 'pageview', $location.path());
					}
				}

				if (portalSettings['GoogleTagManagerId']) {
					if ($rootScope.LoggedInUser && $rootScope.LoggedInUser.Id > 0 && !$rootScope.GATHasSetUserId) {
						$window.dataLayer.push({
							userId: $rootScope.LoggedInUser.Id,
						});
						$rootScope.GATHasSetUserId = true;
					}

					$window.dataLayer.push({
						event: 'pageView',
						attributes: {
							route: $location.path(),
						},
					});
				}
			}

			if ($rootScope.HasAcceptedCookieOfType('marketing')) {
				trackMarketingPageView();
			}

			var path = window.location.pathname;
			if (bizUser.IsLoggedIn()) {
				userService.AddUserActivity(
					path + '#/admin' + $transition.$to().url,
					path + '#/admin' + $transition.$from().url,
					'PAGEVISITS'
				);
			}

			if (portalSettings.maxWidth.length > 0) {
				setTimeout(function () {
					$('#base-home').css('max-width', portalSettings.maxWidth);
					$('#base-home').css('width', '100%');
					$('#base-home').css('margin', 'auto');
				}, 0);
			}

			$rootScope.LastPageLoadTime = moment();

			sessionService.Refresh();
		});

		$transitions.onStart({}, function ($transition) {
			bizPageSurfaceService.Clear();

			var to = $transition.$to();

			function EvaluateAccessRule(to, noAccessState = 'noaccess') {
				if (to.data && angular.isFunction(to.data.rule)) {
					var result = to.data.rule();
					if (!result) {
						$transition.abort();
						$state.go(noAccessState);
					}
				}
			}

			if (IsPortalSettingTrue('IsPortalPublic')) {
				EvaluateAccessRule(to, 'base.home');

				return;
			}

			if (!bizUser.IsLoggedIn() && (!to.data || !to.data.isPublic)) {
				$transition.abort();
				$state.go('login');
				return;
			} else if (bizUser.IsLoggedIn() && to.data && to.data.onlyLoggedOut) {
				$transition.abort();
				$state.go('base');
				return;
			}

			if (baseService.RedirectUrls && baseService.RedirectUrls[to.name]) {
				$transition.abort();
				$state.go(baseService.RedirectUrls[to.name]);
				return;
			}

			if (to.self.data && to.self.data.translateParts && to.self.data.translateParts.length) {
				for (var i = 0; i < to.self.data.translateParts.length; i++) {
					$translatePartialLoader.addPart(to.self.data.translateParts[i]);
				}
			}

			EvaluateAccessRule(to);
		});

		//SIGNALR NOTIFICATIONS!
		$rootScope.MsgQueue = [];

		$rootScope.$on('SHOW_CUSTOM_NOTIFICATION', function (event, message) {
			bizNotificationService.AddCustomNotification(message);
		});

		$rootScope.$on('HUB_ConnectionStateChange', function (event, args) {
			if (args == 'CONNECTED') {
				//console.log('SignalR connected! Sending message queue.');
				SendMessageQueue();
			}
		});

		$rootScope.$on('SignalR.serverMessage', function (event, args) {
			//console.info(
			//    'Received SignalR.serverMessage with hub server name ' +
			//        args.HubServerName +
			//        ' and hub key ' +
			//        args.HubKey
			//);

			if (args.ConnectionId) {
				console.log('Setting SignalRConnectionId to ' + args.ConnectionId);
				$rootScope.SignalRConnectionId = args.ConnectionId;
				return;
			}

			if (args.HubServerName == 'HubGeneric') {
				$rootScope.$broadcast('HUB_' + args.HubKey, args);
			} else {
				$rootScope.$broadcast('HUB_' + args.HubServerName, args);
			}
		});

		$rootScope.$on('HUB_HubNotification', function (event, args) {
			var content = JSON.parse(args.Content);
			if (content.Key == 'CUSTOM') {
				bizNotificationService.AddCustomNotification(content.Message);
			} else {
				bizNotificationService.AddInformationNotification(content.Subject, content.Message);
			}
		});

		$rootScope.SendHubMessageToServer = SendHubMessageToServer;
		window.addEventListener('HubClientSendServerMsg', HubClientSendServerMessage, false);

		function SendHubMessageToServer(hubKey, content, hubServerName) {
			var serverMsg = {
				HubServerName: hubServerName || 'HubGeneric',
				HubKey: hubKey,
				Content: content,
			};

			var evt = document.createEvent('CustomEvent');
			evt.initCustomEvent('HubClientSendServerMsg', true, true, {
				d: serverMsg,
			});
			window.dispatchEvent(evt);
		}

		function HubClientSendServerMessage(data) {
			var result = data.detail.d;
			if (result) {
				$rootScope.MsgQueue.push(result);
				SendMessageQueue();
			}
		}

		function SendMessageQueue() {
			if (SignalRFactory.IsHubconnected) {
				while ($rootScope.MsgQueue.length > 0) {
					var msg = $rootScope.MsgQueue.splice(0, 1);
					SignalRFactory.send(JSON.stringify(msg[0]));
				}
			}
		}

		SignalRFactory.connect();

		initReactAngularJSEventBridge();

		function initReactAngularJSEventBridge() {
			// AngularJS → React: broadcast event in AngularJS and relay to window for React
			// Usage: $rootScope.bizBroadcast('MyEvent', { some: 'data' });
			// Switch out regular $rootScope.$broadcast with bizBroadcast - if you want the event to be available in React as well
			$rootScope.bizBroadcast = function (eventName, ...args) {
				$rootScope.$broadcast(eventName, ...args);

				// Relay to window (React can listen here)
				window.dispatchEvent(
					new CustomEvent('ng:biz-event-bus', {
						detail: {
							type: eventName,
							payload: args,
						},
					})
				);
			};

			// React → AngularJS: listen for events coming from React
			window.addEventListener('react:biz-event-bus', (e) => {
				console.log('Received event from React: ', e.detail);

				// Prevent digest issues
				$rootScope.$applyAsync(() => {
					$rootScope.$broadcast(e.detail.type, e.detail.payload);
				});
			});
		}
	}

	//TODO: Add so when we get 401 error we give info to user...
	function loadingInterceptorFunction($q) {
		function isUrlForTemplateCache(url) {
			var urlLC = url.toLowerCase();
			for (var i = 0; i < htmlTemplateCachePaths.length; i++) {
				if (urlLC.indexOf(htmlTemplateCachePaths[i]) >= 0) {
					return true;
				}
			}
			return false;
		}

		return {
			request: function (request) {
				var htmlIndex = request.url.indexOf('.html');
				if (htmlIndex > 0 && htmlIndex == request.url.length - 5 && isUrlForTemplateCache(request.url) == false) {
					request.url = request.url + '?v=' + bizPartVersion;
				}

				//request.headers.RequestKey = "TESTING";

				return request;
			},
			response: function (response) {
				if (debugTimes.enabled == true && response.headers('Server-Timing')) {
					var regExp = /([\d]{1,})/gim;
					var match = regExp.exec(response.headers('Server-Timing'));
					if (match != null && match.length > 0) {
						var totalTime = 0;
						for (var i = 0; i < match.length; i++) {
							totalTime += ~~match[i];
						}

						if (totalTime > debugTimes.threshold) {
							console.error(
								'Function took ' + totalTime + 'ms to execute in the backend. Method: ' + response.config.url
							);
						}
					}
				}

				return response || $q.when(response);
			},
			responseError: function (rejection) {
				//Send error report...
				// if(rejection.code == 500) {

				// }
				return $q.reject(rejection);
			},
		};
	}

	function OnLoad() {
		var expectedBrowserToken = getBizPartAuthToken();
		var restartingForSessionChange = false;
		var token = getParameterByNameFromUrl('token', location.href);
		if (!token) {
			token = expectedBrowserToken;
		}

		function RestartIfSessionChanged(responseToken) {
			if (restartingForSessionChange) return true;
			var currentToken = getBizPartAuthToken();
			// A response can set its own cookie before this callback runs.
			if (currentToken === expectedBrowserToken || (responseToken && currentToken === responseToken)) return false;

			// Another tab changed the session. Do not apply this page's stale response.
			restartingForSessionChange = true;
			var currentUrl = new URL(window.location.href);
			if (currentUrl.searchParams.has('token')) {
				currentUrl.searchParams.delete('token');
				window.location.replace(currentUrl.href);
			} else {
				window.location.reload();
			}
			return true;
		}

		var prConfigs = $.Deferred();
		$.ajax({
			url: siteRootPath + 'api/frontend/GetFrontEndConfigurations',
			dataType: 'json',
			method: 'GET',
			headers: {
				'Auth-Token': token,
			},
		}).then(function (configs) {
			viewOverrides = configs.ViewOverrides;

			urlReMapper = configs.UrlReMapper;
			notificationSettings = configs.NotificationSettings;
			menuSettings = configs.MenuSettings;
			mascot = configs.Mascot;
			journeySettings = configs.JourneySettings;
			prConfigs.resolve();
		});

		var prUser = $.Deferred();

		initialUrl = getParameterByNameFromUrl('url', location.href);
		var lang = getParameterByNameFromUrl('lang', location.href);
		var queryString = '';

		if (lang) {
			queryString = '?lang=' + lang;
		}

		$.ajax({
			url: siteRootPath + 'api/User/GetLoggedInUserSession' + queryString,
			dataType: 'json',
			headers: {
				'Auth-Token': token,
			},
		}).then(
			function (userSession) {
				if (RestartIfSessionChanged(userSession.Token)) return;
				if (userSession.Token && userSession.Token != '') {
					setBizPartAuthToken(userSession.Token, userSession.UserId);
				}
				expectedBrowserToken = getBizPartAuthToken();
				userData = userSession.User;
				cultureCode = userSession.CultureCode;
				currentCultureId = userSession.CultureId;
				sessionTimeoutInSeconds = userSession.SessionTimeInMinutes * 60;
				limitedAccessModeUnit = userSession.LimitedAccessMode?.Unit;
				prUser.resolve();
			},
			function () {
				if (RestartIfSessionChanged()) return;
				prUser.resolve();
			}
		);

		var prFavorites = $.Deferred();
		$.when(prUser).then(function () {
			if (IsPortalSettingTrue('IsFavoritesEnabled') && userData.Id > 0) {
				$.ajax({
					url: siteRootPath + 'api/favorites/GetFavorites?deepload=false',
					dataType: 'json',
					method: 'GET',
					headers: {
						'Auth-Token': token,
					},
				}).then(
					function (favorites) {
						favoriteObjects = favorites;
						prFavorites.resolve();
					},
					function () {
						prFavorites.resolve();
					}
				);
			} else {
				prFavorites.resolve();
			}
		});

		$.when(prConfigs, prUser, prFavorites).then(function () {
			if (RestartIfSessionChanged()) return;
			angular.bootstrap(document, ['bizPartEngage'], { strictDi: false }); //set to true to debug minification errors un-minified
		});
	}

	window.addEventListener('load', OnLoad);
})(window.angular);
